import {connect} from 'react-redux';
import SupporterShiftsBlock from '../../../components/blocks/supporter/SupporterShiftsBlock';
import {appDialogShiftDetailsOpen} from '../../../actions/appAction';

const mapStateToProps = (state, ownProps) => {
    return {
        supporterId: ownProps.supporterId
    }
};

const mapDispatchToProps = dispatch => {
    return {
        openShiftDetailsDialog: (shiftId) => {
            dispatch(appDialogShiftDetailsOpen(shiftId))
        }
    }
};

const SupporterShiftsBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterShiftsBlock);

export default SupporterShiftsBlockContainer;